// extracted by mini-css-extract-plugin
export default {"popover-icon":"KftPF_fAWenglcUJ9fKI","popoverIcon":"KftPF_fAWenglcUJ9fKI"};